var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"pt-12 pb-12",attrs:{"text-center":""}},[_c('v-icon',[_vm._v("block")]),_c('h1',{staticClass:"headline"},[_vm._v("404 Page Not Found")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }